export const table = {
	defaultCategoryName: "Produtos",
	exportExcel: "Exportar Excel",
	productCount: {
		singular: "produto",
		plural: "produtos",
	},
	loading: {
		categories: "Carregando categorias",
		products: "Carregando Produtos",
	},
	dropdown: {
		editCategory: "Editar categoria",
		deleteCategory: "Excluir categoria",
		categoryButton: "Categoria",
	},
	columns: {
		bars: "Bares",
		barsTooltip: "Clique para visualizar os bares",
		barsLabel: "Bares",
		mountableTooltip: "Clique para ver o produto montável",
		productionRuleTooltip: "Clique para ver a regra de produção",
		active: "Status",
		mountableDescription: "Montável",
		fiscalCode: "SKU",
		name: "Produto",
		hasProductionRule: "Ficha Técnica",
		fiscalData: "Dados Fiscais",
		value: "Preço",
		actions: "Ações",
	},
	fiscalStatus: {
		testedTooltip: "Dados fiscais cadastrados e validados",
		errorTooltip: "Encontramos erros nos dados fiscais apresentados",
		notTestedTooltip: "Dados fiscais cadastrados. Aguardando teste.",
	},
	variablePrice: "Variável",
	validation: {
		pricePositive: "O preço deve ser um valor positivo",
	},
	priceUpdateSuccess: "O preço de {{productName}} foi atualizado com sucesso.",
	notifications: {
		copyImageSuccess: {
			title: "Sucesso!",
			description: "Hash da imagem copiado para a área de transferência",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Categoria sem produtos",
		noProductsFound: "Nenhum produto encontrado",
		addProducts: "Adicione produtos e vincula a está categoria.",
		noSearchResults: "Não encontramos produtos que correspondam à sua busca por",
		clearSearchButton: "Limpar busca",
		clearFiltersButton: "Limpar filtros",
		andToAppliedFilters: "e aos filtros aplicados",
		inCategory: 'na categoria "{{categoryName}}"',
		noProductsMatchingFilters:
			"Não encontramos produtos que correspondam aos filtros aplicados",
	},
};
